import { Component } from "@angular/core";
import { NavigationComponent } from "./_components/navigation/navigation.component";
import { NavigationFooterComponent } from "./_components/navigation-footer/navigation-footer.component";

import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";

@Component({
    selector: 'app-pages',
    templateUrl: './pages.component.html',
    styleUrls: ['./pages.component.scss'],
    standalone: true,
    imports: [RouterModule, CommonModule, NavigationComponent, NavigationFooterComponent]
})
export class PagesComponent{


  

}
